<div class="container">
  <div class="row">
    <!-- Centre Selection -->
<!--    <mat-form-field class="col-md-4" appearance="outline">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select [(ngModel)]="selectedCentre" (selectionChange)="mSearch()">-->
<!--        <mat-option *ngFor="let c of centres$ | async" [value]="c">{{ c.centreName }}</mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

    <app-searchable-select class="col-md-4"
                           [options]="centres$ | async"
                           [selectedValue]="selectedCentre"
                           [displayWithFn]="displayCentre"
                           [placeholder]="'Select Centre'"
                           [label]="'Select Centre'"
                           (selectionChange)="onCentreSelect($event)"
    ></app-searchable-select>


    <mat-form-field class="col-md-4" appearance="outline">
      <mat-label>Filter by Hospital</mat-label>
      <mat-select [(ngModel)]="hospitalFilter" (selectionChange)="applyHospitalFilter(hospitalFilter)">
        <mat-option *ngFor="let hospital of hospitals" [value]="hospital">{{ hospital }}</mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Search Button -->
    <button mat-mini-fab color="accent" (click)="mSearch()">
      <mat-icon>search</mat-icon>
    </button>

    <!-- Clear Button -->
    <button class="mx-2" mat-mini-fab color="accent" (click)="Clear()">
      <mat-icon>clear</mat-icon>
    </button>



  </div>



  <div class="card p-2">

    <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Child Wise Hospital Report</h2>
        </li>

      </ul>
      <ul class="header-buttons mr-2">

        <li>
          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Child Wise Hospital" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]">
            <img src="assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <!-- Hospital Name Filter -->


    <!-- Excel Export Button -->


    <!-- Table -->
    <table mat-table [dataSource]="dataSource" id="excel-table">
      <ng-container matColumnDef="DoA">
        <th mat-header-cell *matHeaderCellDef> DoA </th>
        <td mat-cell *matCellDef="let element"> {{getDate(element.dateOfAdmission)|date:'dd/MM/yyyy'}} </td>
      </ng-container>
      <!-- Centre Name Column -->
      <ng-container matColumnDef="centreName">
        <th mat-header-cell *matHeaderCellDef> Centre Name </th>
        <td mat-cell *matCellDef="let element"> {{element.centreName}} </td>
      </ng-container>

      <!-- Child Name Column -->
      <ng-container matColumnDef="childName">
        <th mat-header-cell *matHeaderCellDef> Child Name </th>
        <td mat-cell *matCellDef="let element"> {{element.firstName}} {{element.lastName}} </td>
      </ng-container>

      <!-- Hospital Name Column -->
      <ng-container matColumnDef="hospital">
        <th mat-header-cell *matHeaderCellDef> Hospital Name </th>
        <td mat-cell *matCellDef="let element"> {{element.hospital}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let element"> {{element.status}} </td>
      </ng-container>

      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <!-- Paginator -->
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" aria-label="Select page of users"></mat-paginator>
  </div>
</div>
